/**
 * 设置 Cookie（适用于 helloklarity.com 及其所有子域名）
 * @param key Cookie 键名
 * @param value Cookie 值
 * @param days 过期天数，可选，默认 7 天
 */

import { isDevEnv, isTestEnv } from 'constants/common';
import {
    getUserToken,
    getLocalStoreProviderTokenSetTime,
    getScheduleToken,
    setScheduleToken,
    setUserToken,
    setLocalStoreProviderTokenSetTime,
} from 'utils/localstore';

export const COOKIE_KEYS = {
    PROVIDER_TOKEN: 'provider_token',
    PROVIDER_TOKEN_SET_TIME: 'provider_token_set_time',
    LOGOUT_TIME: 'logout_time',
};

export const setCookie = (key: string, value: string, days = 15) => {
    if (typeof window === 'undefined') {
        return;
    }
    const { hostname } = window.location;
    if (!hostname || (!hostname.includes('boxpractice.com') && !hostname.includes('helloklarity.com'))) {
        //https://app.kiwihealth.com/
        return;
    }
    let domain = '.helloklarity.com';
    if (isDevEnv()) {
        domain = '.klarity-dev.boxpractice.com';
    } else if (isTestEnv()) {
        domain = '.klarity-test.boxpractice.com';
    }
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    // domain 需设置为主域以支持所有子域
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(
        value,
    )}; expires=${expires}; domain=${domain}; path=/`;
};

/**
 * 获取指定 Cookie
 * @param key Cookie 键名
 * @returns Cookie值（不存在则返回 null）
 */
export const getCookie = (key: string): string | null => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [k, v] = cookie.split('=');
        if (decodeURIComponent(k) === key) {
            return decodeURIComponent(v);
        }
    }
    return null;
};

export const setCookieProviderTokenSetTime = (time: number) => {
    setCookie(COOKIE_KEYS.PROVIDER_TOKEN_SET_TIME, `${time}`, 30);
};

export const getCookieProviderTokenSetTime = (): number => {
    const time = getCookie(COOKIE_KEYS.PROVIDER_TOKEN_SET_TIME);
    return time ? parseInt(time, 10) : 0;
};

export const setCookieProviderToken = (token: string) => {
    setCookie(COOKIE_KEYS.PROVIDER_TOKEN, token);
};

export const getCookieProviderToken = (): string | null => {
    return getCookie(COOKIE_KEYS.PROVIDER_TOKEN);
};

export const setCookieLogoutTime = (time: number) => {
    setCookie(COOKIE_KEYS.LOGOUT_TIME, `${time}`, 30);
};

export const getCookieLogoutTime = (): number => {
    const time = getCookie(COOKIE_KEYS.LOGOUT_TIME);
    return time ? parseInt(time, 10) : 0;
};

// 保持原状，不同步meeting的login状态，只把这边的login状态传递给meeting站点
export const handleUsingLatestToken = () => {
    const cookieProviderToken = getCookieProviderToken();
    const localStoreProviderToken = getUserToken();

    const localStoreProviderTokenSetTime = getLocalStoreProviderTokenSetTime();
    const cookieProviderTokenSetTime = getCookieProviderTokenSetTime();

    const cookieLogoutTime = getCookieLogoutTime();

    if (!cookieProviderTokenSetTime) {
    }
    //provider
};

/**
 * 从跨子域共享 cookie 同步 provider token 到本地 schedule-token。
 *
 * @returns 是否发生了同步（采用了 cookie 中的 token）
 */
export const syncScheduleTokenFromCookie = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }
    const cookieToken = getCookieProviderToken();
    if (!cookieToken) {
        return false;
    }
    const localToken = getScheduleToken();
    // 已一致，无需处理
    if (cookieToken === localToken) {
        return false;
    }
    const cookieSetTime = getCookieProviderTokenSetTime();
    const localSetTime = getLocalStoreProviderTokenSetTime();
    // 仅当 cookie 的 token 不更旧时采用（cookie 是「最近一次登录」的来源）
    if (cookieSetTime >= localSetTime) {
        setScheduleToken(cookieToken);
        setUserToken(cookieToken);
        setLocalStoreProviderTokenSetTime(cookieSetTime);
        return true;
    }
    return false;
};
